/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNumber4 = createReactComponent("outline", "number-4", "IconNumber4", [["path", { "d": "M15 20v-15l-8 11h10", "key": "svg-0" }]]);

export { IconNumber4 as default };
//# sourceMappingURL=IconNumber4.mjs.map
